// extracted by mini-css-extract-plugin
export var anchor = "_49-0";
export var discard = "_49-4";
export var muiTooltipTooltip = "_49-6";
export var notificationBar = "_49-3";
export var saveButtonHoverSlotWrapper = "_49-5";
export var show = "_49-2";
export var spacer = "_49-1";